// extracted by mini-css-extract-plugin
export default {"Reset":"verify_Reset__VlbL2","details":"verify_details__DY5ZY","section":"verify_section__J42Qa","Button":"verify_Button__J6l0v","Bottom":"verify_Bottom__XoDsl"};